import apiRoutes from './api.routes';
import ModelService from './model.service';
import api from './api.service';

const PageService = new ModelService(apiRoutes.pages, '/pages');
PageService.getAll = params => api.catchError(async () => {
  const { data } = await api.get(`${apiRoutes.pages}/get-all`, params);
  return data;
});


PageService.getCover = (filename, w = false, h = false, c = false) => {
  return PageService.getFilePathByDir(`/uploads/${api.subdomain}/pages`, filename, w, h, c);
};

PageService.modelName = 'Page';

export default PageService;



// WEBPACK FOOTER //
// ./src/services/page.service.js